module.exports = __webpack_public_path__ + "static/img/285.c90ed5d4.png";